import { render, staticRenderFns } from "./EditStream.vue?vue&type=template&id=489f431c&"
import script from "./EditStream.vue?vue&type=script&lang=js&"
export * from "./EditStream.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports